const DOUBT_FLOW_STORAGE_KEY = "vidya-kasam:doubt-flow";

function cloneIfObject(value) {
  return value && typeof value === "object" ? { ...value } : null;
}

function toPositiveNumber(value, fallback = 0) {
  const nextValue = Number(value);
  return Number.isFinite(nextValue) && nextValue > 0 ? nextValue : fallback;
}

export function getStoredDoubtFlowState() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const rawValue = window.sessionStorage.getItem(DOUBT_FLOW_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : {};
  } catch (_error) {
    return {};
  }
}

export function buildDoubtFlowState(routeState = {}, fallbackState = {}) {
  const mergedState = {
    ...fallbackState,
    ...routeState,
  };

  const categoryId = toPositiveNumber(
    mergedState?.selectedCategory?.category_id ||
      mergedState?.category_id ||
      fallbackState?.category_id,
    2
  );

  const selectedCategory = cloneIfObject(mergedState?.selectedCategory) || {
    category_id: categoryId,
    id: categoryId,
    title: mergedState?.category_name || mergedState?.categoryName || "Doubts",
    category_name: mergedState?.category_name || mergedState?.categoryName || "Doubts",
  };

  const listQueryState = cloneIfObject(mergedState?.listQueryState) || {};

  const qbankBackTarget = mergedState?.qbankBackTarget
    ? {
        pathname: mergedState.qbankBackTarget.pathname,
        state: cloneIfObject(mergedState.qbankBackTarget.state) || {},
      }
    : null;

  return {
    ...fallbackState,
    ...routeState,
    selectedCategory,
    listQueryState,
    category_id: categoryId,
    qbankBackTarget,
  };
}

export function persistDoubtFlowState(flowState) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      DOUBT_FLOW_STORAGE_KEY,
      JSON.stringify(flowState || {})
    );
  } catch (_error) {
    // Ignore storage failures
  }
}

export function buildDoubtBackTarget(pathname, state = {}) {
  return {
    pathname,
    state: buildDoubtFlowState({ ...state, qbankBackTarget: null }),
  };
}
